import MicroreelsApi from '../api/MicroreelsApi';
import {
  MicroreelGenerationModel,
  MicroreelSlideGenerationModel,
  MicroreelVideoGenerationModel,
} from '../models/Microreels/MicroreelGenerationModel';
import {ProjectFilter} from '../models/Projects/Project';

class MicroreelsRepository {
  private microreelsApi = new MicroreelsApi();

  public async getMicroreelsList(
    organizationId: string,
    page: number,
    pageSize: number,
    search?: string,
    filter?: ProjectFilter,
  ) {
    return this.microreelsApi.getMicroreelsList(
      organizationId,
      page,
      pageSize,
      search,
      filter,
    );
  }

  public async generateFromPrompt(
    organizationId: string,
    model: MicroreelGenerationModel,
  ) {
    return this.microreelsApi.generateFromPrompt(organizationId, model);
  }

  public async generateFromSlide(
    organizationId: string,
    model: MicroreelSlideGenerationModel,
  ) {
    return this.microreelsApi.generateFromSlide(organizationId, model);
  }

  public async generateFromVideo(
    organizationId: string,
    model: MicroreelVideoGenerationModel,
  ) {
    return this.microreelsApi.generateFromVideo(organizationId, model);
  }

  public async checkGenerationAvailability(organizationId: string) {
    return this.microreelsApi.checkGenerationAvailability(organizationId);
  }

  public async cancelGeneration(organizationId: string) {
    return this.microreelsApi.cancelGeneration(organizationId);
  }

  public async getGenerationStatus(
    organizationId: string,
    generationId?: string,
  ) {
    return this.microreelsApi.getGenerationStatus(organizationId, generationId);
  }

  public async getMicroreelsLibrary(
    organizationId: string,
    page: number,
    pageSize: number,
    isGradable?: boolean,
    search?: string,
  ) {
    return this.microreelsApi.getMicroreelsLibrary(
      organizationId,
      page,
      pageSize,
      isGradable,
      search,
    );
  }

  public async copyMicroreelsToCourse(
    organizationId: string,
    courseId: string,
    folderId: string,
    microreelsIds: string[],
  ) {
    return this.microreelsApi.copyMicroreelsToCourse(
      organizationId,
      courseId,
      folderId,
      microreelsIds,
    );
  }
}

export default MicroreelsRepository;
